import {serialize, serializeAs} from 'libs/cerialize';
export class UpdateRecordLifestatusRequestModel {
    EntityId: number;
	RecordId: number;
    LifestatusId: number;
}